import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const X_ROLES = [
  'sundial-role:X_EXTERNAL',
  'sundial-role:X_INTERNAL',
  'sundial-role:SALES',
  'sundial-role:HUB_INTERNAL_ONCO',
  'sundial-role:HUB_INTERNAL_NEURO',
];

export const hubApplication = {
  name: ApplicationNames.HUB,
  url: envConfig.apps.clinicalPortal,
  roles: X_ROLES,
};
